import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabsContentGenericDetails } from '../../../../../shared/models/tabs-content-generic-details';
import { SalesObjectivesRuleDetailsSalesObjectivesRulesComponent } from '../sales-objectives-rule-details-sales-objectives-rules/sales-objectives-rule-details-sales-objectives-rules.component';

@Component({
    selector: 'app-sales-objectives-rule-tabs-details',
    templateUrl: './sales-objectives-rule-tabs-details.component.html',
    styleUrl: './sales-objectives-rule-tabs-details.component.scss',
    standalone: false
})
export class SalesObjectivesRuleTabsDetailsComponent
  implements OnInit, OnChanges, OnDestroy
{
  active = 1;
  currentActive: number = 1;

  tabsContent$: BehaviorSubject<TabsContentGenericDetails[]> =
    new BehaviorSubject<TabsContentGenericDetails[]>([]);
  tabsInit: TabsContentGenericDetails[] = [
    {
      title: 'Objectifs',
      index: 1,
      name: 'salesObjectives',
      component: SalesObjectivesRuleDetailsSalesObjectivesRulesComponent,
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.tabsContent$.next(this.tabsInit);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentActive) {
      this.active = this.currentActive;
    } else {
      this.active = 1;
    }
    this.tabsContent$.next(this.tabsInit);
  }

  trackByTabsContent(index: any, item: TabsContentGenericDetails) {
    return item.index;
  }

  onActiveIdChangeSaveCurrent(active: number) {
    this.currentActive = active;
  }

  ngOnDestroy(): void {
    this.currentActive = 0;
  }
}
